module.exports = __webpack_public_path__ + "assets/img/busy_10.1aa31596.png";